import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconAuthorStyle0 = cosmosIconCss;

const CosmosIconAuthor$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconAuthor extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'f36faa0e2bcc72b8de1ac8f9fe3cc56486e694ff', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'cb262c2925a59a0e72e489d3ecd44c959e3fbb5f', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '10ae089dd355a868a0f9dd0f55cfc677d7dd815f', d: "M5.55 9.152a2.85 2.85 0 0 0 2.91 2.68 2.85 2.85 0 0 0 2.92-2.68l.29-2.55a3 3 0 0 0-3.21-3.59 3 3 0 0 0-3.21 3.59l.3 2.55Zm6.84 3.77a.24.24 0 0 0-.07-.17l-.19-.19a.24.24 0 0 0-.18-.07.25.25 0 0 0-.17.06 5.06 5.06 0 0 1-3.32 1.28 4.83 4.83 0 0 1-3.26-1.22.5.5 0 0 0-.56-.09 4.58 4.58 0 0 0-2.63 3.28.5.5 0 0 0 .49.6h6.31a.49.49 0 0 0 .35-.15l3.15-3.15a.25.25 0 0 0 .08-.18Zm7.503-1.178c.102-.102.085-.285-.037-.407l-1.326-1.33c-.122-.123-.303-.14-.405-.038l-.92.924 1.767 1.775.921-.925Zm-3.352-.185-4.863 4.88-.7 2.047a.313.313 0 0 0 .391.4l2.078-.674 4.862-4.879-1.768-1.774Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconAuthorStyle0; }
}, [1, "cosmos-icon-author", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-author"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-author":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconAuthor$1);
            }
            break;
    } });
}

const CosmosIconAuthor = CosmosIconAuthor$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconAuthor, defineCustomElement };
